var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c("div", { staticClass: "container is-fluid" }, [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-3" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm.user
              ? _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "media" }, [
                    _c(
                      "div",
                      { staticClass: "media-left" },
                      [
                        _c("b-icon", {
                          attrs: { icon: "user", size: "is-small" },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "media-content" }, [
                      _c("p", { staticClass: "title is-4" }, [
                        _vm._v(" " + _vm._s(_vm.user.displayName) + " "),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "content" }, [
                    _c("div", [
                      _c("ul", [
                        _c("li", [
                          _vm._v(
                            " Username : " + _vm._s(_vm.user.username) + " "
                          ),
                        ]),
                        _c("li", [
                          _vm._v(
                            " Mail : " + _vm._s(_vm.user.email || "N/A") + " "
                          ),
                        ]),
                        _c(
                          "li",
                          [
                            _c(
                              "b-taglist",
                              [
                                _vm._v(" Customer(s) : "),
                                _vm._l(
                                  _vm.user.group.customers,
                                  function (customer) {
                                    return _c("b-tag", { key: customer.id }, [
                                      _vm._v(" " + _vm._s(customer.name) + " "),
                                    ])
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-image" }, [
      _c("figure", { staticClass: "image is-4by3" }, [
        _c("img", {
          attrs: {
            src: "https://picsum.photos/400?random",
            alt: "Placeholder image",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }